module.exports = __webpack_public_path__ + "img/yellow.8fb01a50.png";